import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCol,{staticClass:"card"},[_c(VCard,{staticClass:"com-pc-card if-srch-card"},[_c('div',{staticClass:"com-pc-card-header if-srch-header"},[_c('span',{staticClass:"com-pc-card-title"},[_vm._v("お知らせ検索・検索一覧")])]),_c('if-search')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }